import { message } from "antd";
import { GET, PUT } from "../../../services/api";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";
import { clientTypes } from "../../type/clientTypes";
import { toast } from "react-toastify";

export const getBrandingData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: clientTypes.GET_BRANDING_DATA_PENDING,
        isLoading: true,
      });
      const res = await GET(`${ApiUrl.CLIENT_BRANDING}`, payload);
      dispatch({
        type: clientTypes.GET_BRANDING_DATA_SUCCESS,
        payload: res.data?.result ?? [],
        isLoading: false,
        msg: res.data.message ?? "",
      });
    } catch (error) {
      dispatch({
        type: clientTypes.GET_BRANDING_DATA_FAILED,
        payload: [],
        isLoading: false,
        msg: (error && error?.message) ?? "",
      });
    }
  };
};

export const updateBranding = (values, callback) => {
  return async () => {
    const res = await PUT(`${ApiUrl.CLIENT_BRANDING}`, values);
    if (res?.data?.code === 200) {
      toast.success(res?.data?.message);
      localStorage.setItem("LOGO", values.logo);
      callback(res);
    } else {
      toast.error(res?.data?.message);
    }
  };
};
